import { render, staticRenderFns } from "./Expertthinktank.vue?vue&type=template&id=bb58f136&scoped=true&"
import script from "./Expertthinktank.vue?vue&type=script&lang=js&"
export * from "./Expertthinktank.vue?vue&type=script&lang=js&"
import style0 from "./Expertthinktank.vue?vue&type=style&index=0&id=bb58f136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58f136",
  null
  
)

export default component.exports